<div style="margin: 20px; min-height: 700px; min-width: 1200px;">
  <div class="btn-group">
    <p-button name="add" [routerLink]="'./new'" title="Dodaj konfigurację walidacji" label="Dodaj konfigurację"></p-button>
  </div>
  <p-table [value]="configs" [paginator]="true" [rows]="limit" [(first)]="parent.first">
    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;">
        <th width="50">Id</th>
        <th width="150">Nazwa</th>
        <th>Opis</th>
        <th width="200">Posiadacz walidatora</th>
        <th width="150">Akcja</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-config>
      <tr style="white-space: normal; overflow-wrap: break-word">
        <td>{{config.id}}</td>
        <td>{{config.name}}</td>
        <td>{{config.description}}</td>
        <td>{{config.validationProvider.label}}</td>
        <td>
          <fa-stack size="1x" style="cursor: pointer; float: right;" (click)="deleteRow(config)" title="Usuń">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="times" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack size="1x" style="cursor: pointer; float: right;" (click)="gotoEdit(config)" title="Edytuj">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="edit" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
          <fa-stack size="1x" style="cursor: pointer; float: right;" [routerLink]="'./' + config.id + '/permission'" title="Uprawnienia">
            <fa-icon icon="square" stackItemSize="2x"></fa-icon>
            <fa-icon icon="bars" [inverse]="true" stackItemSize="1x"></fa-icon>
          </fa-stack>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div align="right">
    <p-button class="button" routerLink="/validators" label="Zamknij"></p-button>
  </div>
</div>
